// @flow
import * as classNames from 'classnames';
import * as React from 'react';
import PhoneInput from 'react-phone-number-input/max';
import 'react-phone-number-input/style.css';
import '../Checkout/Checkout.css';
import CountrySelectNative  from '../CountrySelect/CountrySelect';
import getCountryNameFromCode from '../CountrySelect/CountryCodeMap' ;

import { isValidPhoneNumber } from 'react-phone-number-input';

import './PhoneField.css';

class PhoneField extends React.PureComponent{
    constructor(props) {
        super(props);
        this.state = {
            touched: false
        };
    }

    onCountryChange = (e) => {
        if (this.props.handleOnCountryChange !== undefined)
            this.props.handleOnCountryChange(getCountryNameFromCode(e));
    }

    onChangeInput = (e) => {
        this.props.handleOnChange(e);
    }

    onBlurInput = (e) => {
        this.setState({
            touched: true
        });
        this.props.handleOnBlur && this.props.handleOnBlur(e);
    }

    onFocusInput = (e) => {
        this.setState({
            touched:false
        });
        this.props.handleOnFocus && this.props.handleOnFocus(e);
    }

    render() {
        let valid = this.props?.value ? isValidPhoneNumber(this.props.value) : false;
        let errorMsg = 'Please Enter a Valid Phone Number';
        if (this.props.validators) {
            this.props.validators.forEach((validatorPackage) => {
                if (!valid) {
                    return;
                }
                if (validatorPackage.validator(this.props.value) === false) {
                    valid = false;
                    errorMsg = validatorPackage.errorMessage;
                    console.log('Validating');
                }
            });    
        }
        const showError = this.state.touched && !valid && (this.props.deferErrors === false);
        const TextFieldClasses = classNames('TextField', this.props.className || '' 
        );

        return (
            <div className={TextFieldClasses}>
                <div className={'TextField-label'}>
                    {this.props.label}
                    {this.props.required && (
                        <span className={'TextField-required'}>{' *'}</span>
                    )}
                </div>
                <PhoneInput
                    className={showError? "PhoneField-error-box":null}
                    placeholder={this.props.placeholder}
                    value={ this.props.value || '' }
                    onChange={ this.onChangeInput }
                    onFocus={this.onFocusInput}
                    onBlur={this.onBlurInput}
                    defaultCountry={this.props.defaultCountry || "CA"}
                    // countries={}
                    countryOptionsOrder={["CA","US","CR"]}
                    countrySelectComponent={ CountrySelectNative }
                    onCountryChange={this.onCountryChange }
                    reset=''
                    flagUrl="https://storage.googleapis.com/vault.api.ctrlv.ca/public/static_images/CountryFlags/{XX}.png"
                    // labels={(this.props.labels) ? this.props.labels : undefined}
                    />
                {showError && (
                    <div className={'PhoneField-error-text'}>{errorMsg}</div>
                )}
            </div>
        );
    }
}

export default PhoneField;
